import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Layout from '../../common/Layout';
import ChallengeBuilder from '../ChallengeBuilder/ChallengeBuilder';
import useChallengeStore from '../../store/challengeStore';
import { useChallenge } from '../../hooks/useChallenge';
import LoadingSpinner from '../../common/components/LoadingSpinner/LoadingSpinner';

const ChallengeCreation = () => {
    const { id } = useParams();
    const { reset, loadChallengeData } = useChallengeStore();
    const { data: challengeData, isLoading, error } = useChallenge(id, { enabled: !!id });

    useEffect(() => {
        if (id && challengeData) {
            // Edit mode - load existing challenge data
            const parsedData = typeof challengeData === 'string' 
                ? JSON.parse(challengeData.challengeDefinition) 
                : challengeData.challengeDefinition;
            
            loadChallengeData({
                challengeId: id,
                ...parsedData
            });
        } else if (!id) {
            // Create mode - reset store when creating a new challenge
            reset();
        }
    }, [id, challengeData, reset, loadChallengeData]);

    if (id && isLoading) {
        return (
            <Layout name={id ? "Edit Challenge" : "Challenge Creation"}>
                <LoadingSpinner boxed={true} styles={{ paddingTop: 40, marginTop: 15, marginBottom: 30 }} />
            </Layout>
        );
    }

    if (id && error) {
        return (
            <Layout name="Edit Challenge">
                <div>Error loading challenge: {error.message}</div>
            </Layout>
        );
    }

    return (
        <Layout name={id ? "Edit Challenge" : "Challenge Creation"}>
            <ChallengeBuilder />
        </Layout>
    );
};

export default ChallengeCreation;
